import { render, staticRenderFns } from "./FollowRecord.vue?vue&type=template&id=3641089f&scoped=true"
import script from "./FollowRecord.vue?vue&type=script&lang=js"
export * from "./FollowRecord.vue?vue&type=script&lang=js"
import style0 from "./FollowRecord.vue?vue&type=style&index=0&id=3641089f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641089f",
  null
  
)

export default component.exports